// @flow
import TradingPage from './TradingPage';
import connect from './connect';

export default connect(TradingPage);



// WEBPACK FOOTER //
// ./src/app/TradingPage/index.js